import { tKey, type I18nKey } from "@/core/i18n";
import { DashboardConfigurationZoneDirectionEnum } from "@repo/schema";
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const options: {
  value: DashboardConfigurationZoneDirectionEnum;
  label: I18nKey<"dashboard">;
  Icon: typeof ArrowRight;
}[] = [
  {
    value: DashboardConfigurationZoneDirectionEnum.LEFT_TO_RIGHT,
    label: tKey("dashboard:direction.LEFT_TO_RIGHT"),
    Icon: ArrowRight,
  },
  {
    value: DashboardConfigurationZoneDirectionEnum.RIGHT_TO_LEFT,
    label: tKey("dashboard:direction.RIGHT_TO_LEFT"),
    Icon: ArrowLeft,
  },
  {
    value: DashboardConfigurationZoneDirectionEnum.TOP_TO_BOTTOM,
    label: tKey("dashboard:direction.TOP_TO_BOTTOM"),
    Icon: ArrowDown,
  },
  {
    value: DashboardConfigurationZoneDirectionEnum.BOTTOM_TO_TOP,
    label: tKey("dashboard:direction.BOTTOM_TO_TOP"),
    Icon: ArrowUp,
  },
];

interface DirectionPickerProps {
  value: DashboardConfigurationZoneDirectionEnum;
  onChange: (value: DashboardConfigurationZoneDirectionEnum) => void;
}

export const DirectionPicker = ({ value, onChange }: DirectionPickerProps) => {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <div className="inline-flex h-9 items-center rounded-md border border-input bg-muted p-0.5 text-sm">
      {options.map(({ value: optionValue, label, Icon }) => {
        const isSelected = value === optionValue;
        return (
          <button
            key={optionValue}
            type="button"
            aria-label={t(label)}
            title={t(label)}
            className={`flex h-8 w-9 cursor-pointer items-center justify-center rounded-sm transition-colors ${
              isSelected
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
            onClick={() => onChange(optionValue)}
          >
            <Icon className="size-4" />
          </button>
        );
      })}
    </div>
  );
};
